export default __webpack_public_path__ + "static/media/logofurnish.2f5ac1bd.png";